import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectSubscriptionList } from 'root-redux/selects/common'
import { Option, OptionType } from 'components/Option'
import { selectSubscriptionPriceId } from 'modules/purchase/redux/selects'
import { setSelectedSubscriptionAction } from 'modules/purchase/redux/actions'
import { ISubscription } from 'models/subscriptions.model'
import { SubscriptionItemV2 } from 'modules/purchase/components/SubscriptionItemV2'
import { StyledSubscriptionsBlockV2 as S } from './SubscriptionsBlockV2.styles'

type TProps = {
  elemForComparisonRef: React.RefObject<HTMLDivElement>
  onButtonClick: () => void
}

export const SubscriptionsBlockV2: React.FC<TProps> = ({
  elemForComparisonRef,
  onButtonClick,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const subscriptions = useSelector(selectSubscriptionList)
  const selectedSubscriptionPriceId = useSelector(selectSubscriptionPriceId)

  const defaultSubscription = subscriptions.find(({ isDefault }) => isDefault)
  const selectedSubscriptionInstance = subscriptions.filter(
    (subscription) => subscription.priceId === selectedSubscriptionPriceId,
  )[0]
  const [selectedSubscription, setSelectedSubscription] =
    useState<ISubscription | null>(
      selectedSubscriptionInstance || defaultSubscription,
    )

  useEffect(() => {
    dispatch(
      setSelectedSubscriptionAction(selectedSubscription as ISubscription),
    )
  }, [dispatch, selectedSubscription])

  const handleChange = useCallback(
    (value) => {
      const checkedSubscription = subscriptions.find(
        (subscription) => subscription.priceId === value,
      )
      setSelectedSubscription(checkedSubscription as ISubscription)
    },
    [subscriptions],
  )

  return (
    <S.Wrapper>
      <S.Title>{t`purchase.subscription.title`}</S.Title>
      {subscriptions.map((subscription) => (
        <Option
          type={OptionType.RADIO}
          name="subscription"
          value={subscription.priceId}
          key={subscription.priceId}
          onChange={handleChange}
          withoutMargin
        >
          <SubscriptionItemV2
            subscription={subscription}
            isSelected={subscription.priceId === selectedSubscriptionPriceId}
          />
        </Option>
      ))}
      <S.ButtonContainer ref={elemForComparisonRef}>
        <S.Button type="button" onClick={onButtonClick}>
          {t`actions.startNow`}
        </S.Button>
      </S.ButtonContainer>
    </S.Wrapper>
  )
}
